
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8DuT4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Trackers", () => $0d33cd7f173f9f04$export$a2c5350cd99575c4);
$parcel$export(module.exports, "default", () => $0d33cd7f173f9f04$export$2e2bcd8739ae039);

var $g3aMe = parcelRequire("g3aMe");

var $3phh3 = parcelRequire("3phh3");
const $0d33cd7f173f9f04$export$a2c5350cd99575c4 = ()=>{
    (0, $g3aMe.useProjectContextReporter)();
    (0, $3phh3.useRecentProjectTracker)();
    return null;
};
var $0d33cd7f173f9f04$export$2e2bcd8739ae039 = $0d33cd7f173f9f04$export$a2c5350cd99575c4;

});
parcelRegister("g3aMe", function(module, exports) {

$parcel$export(module.exports, "useProjectContextReporter", () => $c4b812cb038e6256$export$57c2053bbe217389);

var $5uXOq = parcelRequire("5uXOq");

var $lpwtK = parcelRequire("lpwtK");

var $8zOmE = parcelRequire("8zOmE");
var $d22NM = parcelRequire("d22NM");
const $c4b812cb038e6256$var$convertToAnalyticsProjectType = (projectType)=>projectType === 'service_desk' ? 'serviceDesk' : projectType;
const $c4b812cb038e6256$export$57c2053bbe217389 = ()=>{
    const { data: project } = (0, $lpwtK.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const projectId = project?.id;
    const projectType = project?.type;
    const isSimplified = project?.isSimplified;
    (0, $5uXOq.useEffect)(()=>{
        if (projectId == null || projectType == null) return;
        const event = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(event, 'projectContainer entered', {
            projectId: projectId,
            projectType: $c4b812cb038e6256$var$convertToAnalyticsProjectType(projectType),
            nextGenProject: isSimplified
        });
    }, [
        createAnalyticsEvent,
        projectId,
        projectType,
        isSimplified
    ]);
};

});

parcelRegister("3phh3", function(module, exports) {

$parcel$export(module.exports, "useRecentProjectTracker", () => $f469a6ce31b2e3ca$export$89d3183f2c4acebd);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $2YZCu = parcelRequire("2YZCu");

var $5HnTq = parcelRequire("5HnTq");

var $lpwtK = parcelRequire("lpwtK");

var $cZpsT = parcelRequire("cZpsT");
const $f469a6ce31b2e3ca$export$89d3183f2c4acebd = ()=>{
    (0, $gKZoD.di)(fetch);
    const baseUrl = '';
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { data: project } = (0, $lpwtK.useProject)();
    const projectKey = project?.key;
    (0, $5uXOq.useEffect)(()=>{
        if (isAnonymous || projectKey == null) return;
        const url = `${baseUrl}/rest/api/latest/project/${encodeURIComponent(projectKey)}/tracking/recent`;
        fetch(url, {
            ...(0, $5HnTq.getDefaultOptions)(url),
            method: 'PUT'
        }).then((response)=>{
            if (response.ok) return response;
            throw new Error(`Server didn't accept "${projectKey}", status code: ${response.status}`);
        }).catch((e)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('project-layout.use-recent-project-tracker', 'There was a problem saving recent visited project', e);
        });
    }, [
        baseUrl,
        isAnonymous,
        projectKey
    ]);
};

});
parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});




//# sourceMappingURL=async-project-trackers.bced19cd.js.map
